import { Box } from '@mui/material';

interface Props {
  expanded: boolean;
}

export function Logo({ expanded }: Props) {
  return (
    <Box
      sx={{
        flexShrink: 0,
        height: 64,
        position: 'relative',

        '& .logo, .text': {
          position: 'absolute',
        },

        '& .logo': {
          top: 8,
          left: 13,
        },

        '& .text': {
          bottom: 7,
          left: 5,
          width: 54,
          height: 8,
        },

        '@keyframes textTransition': {
          '0%': { bottom: -4, left: 5, width: 54, opacity: 0 },
          '15%': { left: 56, width: 54 },
          '100%': { bottom: 21, opacity: 1 },
        },

        ...(expanded && {
          '& .logo': {
            top: 13,
            left: 12,
            transition: 'all 0.2s ease-in-out',
          },

          '& .text': {
            bottom: 21,
            left: 56,
            width: 136,
            height: 19,
            animation: 'textTransition 0.2s ease-in-out',
          },
        }),
      }}
    >
      <svg
        className="logo"
        width="38"
        height="38"
        viewBox="0 0 420 420"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <ellipse
            ry="206"
            rx="206"
            cy="210"
            cx="210"
            strokeWidth="0"
            stroke="null"
            fill="#ffffff"
          />
          <path
            fill="#063FFE"
            d="m419.602,221c-5.721,110.867 -97.426,199 -209.716,199c-112.2906,0 -203.99612,-88.133 -209.71732,-199l24.71682,0c75.1395,0 101.1545,28.855 119.4425,99.274c0.53,2.043 3.525,2.027 4.034,-0.02c17.304,-69.625 41.703,-99.254 124.024,-99.254l147.216,0zm0.169,-18l-147.385,0c-75.335,0 -109.308,-31.286 -124.22,-99.239c-0.457,-2.085 -3.54,-2.186 -4.118,-0.131c-19.886,70.666 -47.5116,99.37 -119.1625,99.37l-17.99997,0l-6.88553,0c3.69241,-112.7394 96.2482,-203 209.886,-203c113.637,0 206.193,90.2606 209.885,203z"
            clipRule="evenodd"
            fillRule="evenodd"
          />
        </g>
      </svg>
      <svg
        className="text"
        viewBox="0 0 136 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.7363 10.7197C12.1085 13.8623 9.65659 15.5122 6.57679 15.5122C2.49654 15.5122 0.123047 12.4482 0.123047 8.10742C0.123047 3.68823 2.71239 0.761719 6.73376 0.761719C9.67614 0.761719 12.0497 2.50977 12.6578 5.55419H10.7158C10.2842 3.78645 8.91107 2.45082 6.63567 2.45082C4.12475 2.45082 2.16306 4.415 2.16306 8.10742C2.16306 11.7017 4.04633 13.823 6.69443 13.823C8.9504 13.823 10.3431 12.5463 10.7942 10.7197L12.7363 10.7197ZM14.1405 12.4678C14.1405 9.97338 16.9457 9.24661 21.2809 8.75566V8.50028C21.2809 6.57548 20.202 5.92736 18.8877 5.92736C17.4165 5.92736 16.5533 6.73265 16.4749 8.02889H14.631C14.8075 5.7505 16.8084 4.47383 18.8681 4.47383C21.7712 4.47383 23.0856 5.86841 23.0659 8.83418L23.0463 11.2696C23.0267 13.0374 23.1248 14.2551 23.321 15.2568H21.5163C21.4574 14.8639 21.3985 14.4318 21.379 13.8034C20.7315 14.8836 19.6331 15.5122 17.7695 15.5122C15.7883 15.5122 14.1405 14.4123 14.1405 12.4678ZM21.4182 10.1698C18.1815 10.5037 16.1217 10.9751 16.1217 12.4285C16.1217 13.4302 16.8868 14.098 18.1619 14.098C19.8293 14.098 21.4182 13.332 21.4182 10.8376L21.4182 10.1698ZM27.5109 15.2568H25.7258V4.68995H27.5109V6.28084C28.119 5.27912 29.0998 4.51321 30.6887 4.51321C32.2972 4.51321 33.2584 5.22028 33.7292 6.37905C34.5727 5.08281 35.8086 4.51321 37.2798 4.51321C39.7318 4.51321 40.693 6.16305 40.693 8.57892V15.2568H38.9079V9.10914C38.9079 7.47899 38.5941 6.06484 36.652 6.06484C35.1219 6.06484 34.1019 7.26287 34.1019 9.52168V15.2568H32.3169V9.10914C32.3169 7.47899 32.003 6.06484 30.061 6.06484C28.5309 6.06484 27.5109 7.26287 27.5109 9.52168V15.2568ZM45.154 4.68995V6.35948C45.8014 5.23986 46.9195 4.51321 48.6064 4.51321C51.0193 4.51321 53.1183 6.53622 53.1183 10.0126C53.1183 13.5088 51.0193 15.5122 48.6064 15.5122C46.9195 15.5122 45.8014 14.7854 45.154 13.6659V18.694H43.369V4.68995L45.154 4.68995ZM48.1553 13.9801C49.9796 13.9801 51.1762 12.5267 51.1762 10.0126C51.1762 7.49856 49.9796 6.04515 48.1553 6.04515C46.5664 6.04515 45.0755 7.2236 45.0755 10.0126C45.0755 12.8017 46.5664 13.9801 48.1553 13.9801ZM54.5799 12.4678C54.5799 9.97338 57.3847 9.24661 61.7197 8.75566V8.50028C61.7197 6.57548 60.6416 5.92736 59.3273 5.92736C57.856 5.92736 56.9926 6.73265 56.9146 8.02889H55.0704C55.2466 5.7505 57.248 4.47383 59.307 4.47383C62.2102 4.47383 63.5244 5.86841 63.5052 8.83418L63.486 11.2696C63.4657 13.0374 63.564 14.2551 63.7606 15.2568H61.9559C61.8971 14.8639 61.8384 14.4318 61.818 13.8034C61.1705 14.8836 60.0721 15.5122 58.2086 15.5122C56.2276 15.5122 54.5799 14.4123 54.5799 12.4678ZM61.8576 10.1698C58.621 10.5037 56.5609 10.9751 56.5609 12.4285C56.5609 13.4302 57.326 14.098 58.6018 14.098C60.2687 14.098 61.8576 13.332 61.8576 10.8376V10.1698ZM67.9498 1.0171V3.17759H66.1654V1.0171H67.9498ZM67.9498 4.68995V15.2568H66.1654V4.68995H67.9498ZM77.8832 4.68995H79.6676V13.8427C79.6676 16.0031 79.2754 16.887 78.6674 17.5548C77.9024 18.4387 76.5881 18.9493 75.0196 18.9493C72.6261 18.9493 71.0168 17.8494 70.6835 15.7085H72.5865C72.8216 16.6513 73.3911 17.378 75.0388 17.378C75.9993 17.378 76.726 17.1031 77.1961 16.5924C77.5882 16.1799 77.8832 15.6889 77.8832 14.2551V13.2534C77.2356 14.373 76.2152 15.0801 74.5291 15.0801C72.1944 15.0801 70.0563 13.1945 70.0563 9.79664C70.0563 6.41832 72.1944 4.51321 74.5291 4.51321C76.2152 4.51321 77.2356 5.23986 77.8832 6.35948V4.68995ZM74.98 6.04515C73.234 6.04515 71.9977 7.40035 71.9977 9.79664C71.9977 12.2125 73.234 13.5677 74.98 13.5677C76.5689 13.5677 77.9612 12.4875 77.9612 9.79664C77.9612 7.12539 76.5689 6.04515 74.98 6.04515ZM84.2715 6.28084C84.8795 5.27912 85.8999 4.51321 87.6843 4.51321C90.2349 4.51321 91.157 6.16305 91.157 8.57892V15.2568H89.3715V9.10914C89.3715 7.47899 89.0969 6.06484 87.0571 6.06484C85.3304 6.06484 84.2715 7.26287 84.2715 9.52168V15.2568H82.4871V4.68995H84.2715V6.28084ZM99.8688 7.77363C99.5942 6.51653 98.6133 6.02557 97.3781 6.02557C96.3384 6.02557 95.1609 6.39874 95.1609 7.36108C95.1609 8.20563 95.7497 8.59849 96.7701 8.79492L98.2607 9.08956C100.183 9.46273 101.87 10.1894 101.87 12.2321C101.87 14.314 99.9863 15.5122 97.5736 15.5122C94.8083 15.5122 93.2386 13.6855 93.042 11.8392H94.9258C95.2004 13.1945 96.0435 13.9998 97.6132 13.9998C98.967 13.9998 100.065 13.4105 100.065 12.4285C100.065 11.3678 99.0653 10.9161 97.9273 10.6805L96.3576 10.3662C94.9258 10.0716 93.3562 9.40378 93.3562 7.43972C93.3562 5.57376 95.24 4.49352 97.5736 4.49352C99.8496 4.49352 101.399 5.77019 101.732 7.77363H99.8688ZM108.861 4.68995H110.705L112.804 12.507L114.824 4.68995H116.746L113.707 15.2568H112.078L109.743 6.75222L107.488 15.2568H105.859L102.819 4.68995H104.742L106.762 12.507L108.861 4.68995ZM119.352 10.5625C119.432 12.8409 121.04 13.9409 122.609 13.9409C124.178 13.9409 125.041 13.2338 125.492 12.1928H127.336C126.846 14.0194 125.179 15.5122 122.609 15.5122C119.274 15.5122 117.43 13.1159 117.43 9.99306C117.43 6.65401 119.667 4.51321 122.551 4.51321C125.767 4.51321 127.709 7.2236 127.474 10.5625H119.352ZM119.373 9.03061H125.59C125.551 7.53794 124.433 6.04515 122.551 6.04515C120.962 6.04515 119.529 6.90939 119.373 9.03061ZM131.339 15.2568H129.554V1.0171H131.339V15.2568ZM135.955 15.2568H134.171V1.0171H135.955V15.2568Z"
          fill="#202430"
        />
      </svg>
    </Box>
  );
}
